import _ from 'lodash';

import smartSolveApi from './instances/smartsolve';
import { ENTITY_NAME_DASHBOARD } from '../constants/SavedSearches';

export const getSavedSearchResults = async (savedSearch, customEndpointName) => {
  const metadata = savedSearch.metadata ?? {};
  const extraParams = metadata.params ?? {};

  if (metadata.url) {
    return getCustomSavedSearchData(savedSearch);
  }

  //Some endpoints like /getsmartinsightreports has exactly same structure of payload and response
  //as getsearchdata. They are build as a wrapper for getsearchdata, with additional server logic
  const endpointName = customEndpointName || '/getsearchdata';

  try {
    const response = await smartSolveApi.post(endpointName, {
      ...extraParams,
      ..._.pick(savedSearch, [
        'entityName',
        'currentPageIndex',
        'pageSize',
        'filter',
        'advancedsearchcriteria',
        'sortExpression',
        'referencedColumns',
        'dynamicParamCollection',
      ]),
      savedSearchName: savedSearch.searchName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getSavedSearchResults failed: ${e}`);
  }
};

export const getSavedSearchResultsForAutocomplete = async (requestParams) => {
  try {
    const response = await smartSolveApi.post('/getsearchdata', requestParams);

    return response.data;
  } catch (e) {
    throw new Error(`getSavedSearchResults failed: ${e}`);
  }
};

export const getSavedSearchColumns = async (savedSearch) => {
  const { searchName: savedSearchName, entityName } = savedSearch;
  try {
    const response = await smartSolveApi.post('/getsearchdata', {
      entityName,
      savedSearchName,
      pageSize: 1,
    });

    const { columns } = response.data.SearchData ?? {};
    const { errors } = response.data.hasErrors ?? {};

    return { columns, ...errors };
  } catch (e) {
    throw new Error(`getSavedSearchColumns failed: ${e}`);
  }
};

export const getSavedSearchesByEntity = async (entityName) => {
  if (entityName === ENTITY_NAME_DASHBOARD) {
    return getSavedSearchesForDashboard();
  }

  try {
    const { data } = await smartSolveApi.post('/getsavedsearchesbyentity', {
      entityName,
    });

    if (data.groupedSavedSearches && !data.savedSearches) {
      data.savedSearches = data.groupedSavedSearches.reduce(
        (acc, group) => acc.concat(group.savedSearches),
        []
      );
    }

    return data;
  } catch (e) {
    throw new Error(`getSavedSearches failed: ${e}`);
  }
};

export const getSavedSearchesForDashboard = async () => {
  try {
    const { data } = await smartSolveApi.post('/savedsearchesfordashboard');
    data.groupedSavedSearches = data.savedSearchesForDashboard || [];
    data.savedSearches = data.groupedSavedSearches.reduce(
      (acc, group) => acc.concat(group.savedSearches),
      []
    );
    return data;
  } catch (e) {
    throw new Error(`getSavedSearchesForDashboard failed: ${e}`);
  }
};

export const getSavedSearchExport = async (savedSearch) => {
  const extraParams = savedSearch.metadata?.params ?? {};
  const searchParams = _.pick(savedSearch, [
    'entityName',
    'filter',
    'advancedsearchcriteria',
    'sortExpression',
    'referencedColumns',
    'dynamicParamCollection',
  ]);
  try {
    return await smartSolveApi.post(
      '/exportsearchdata',
      {
        ...extraParams,
        ...searchParams,
        savedSearchName: savedSearch.searchName,
      },
      { responseType: 'blob' }
    );
  } catch (e) {
    throw new Error(`getSavedSearchExport failed: ${e}`);
  }
};

export const getCustomSavedSearchData = async (savedSearch) => {
  try {
    const { url, params } = savedSearch.metadata;

    const response = await smartSolveApi.post(url, {
      ...params,
      ..._.pick(savedSearch, [
        'currentPageIndex',
        'pageSize',
        'filter',
        'advancedsearchcriteria',
        'sortExpression',
        'referencedColumns',
        'dynamicParamCollection',
      ]),
    });

    return response.data;
  } catch (e) {
    throw new Error(`getCustomSavedSearchData failed: ${e}`);
  }
};
